export default __webpack_public_path__ + "static/media/kestrel5.d3bc16bc.jpg";